gsap.registerPlugin(ScrollTrigger);
//gsap.registerPlugin(toggleClass)
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

const accordion = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      const togglers = document.querySelectorAll("[data-toggle]");

      togglers.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          const selector = e.currentTarget.dataset.toggle;
          const block = document.querySelector(`${selector}`);
          if (e.currentTarget.classList.contains("active")) {
            block.style.maxHeight = "";
          } else {
            block.style.maxHeight = block.scrollHeight + "px";
          }

          e.currentTarget.classList.toggle("active");
        });
      });
    });
  },
};

export default accordion;
